import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { pick, prop } from 'ramda';
import { getCleanUrl, getURLParams } from 'js/utils/url.util';
import { useAppSelector, usePageSelector } from 'js/store/hooks';

import { useTriggerCondition } from '../../Emitter';
import { getBasicCondition } from '../../../helpers';
import { BASIC_TAG_LAUNCH_CONDITION } from '../../../constants';

export const useTriggerOnAppInit = () => {
    const location = useLocation();
    // we need to get path from page store but not location because we need background page but not page in popup
    const rootPage = useAppSelector(prop('rootPage'));
    const { friendlyURL, path } = usePageSelector(pick(['friendlyURL', 'path']));
    const [isOnAppInitDone, setIsOnAppInitDone] = useState(false);
    const triggerCondition = useTriggerCondition();
    let page = friendlyURL || path && getCleanUrl(path);

    if (page === '/') {
        page = rootPage;
    }

    useEffect(() => {
        if (page && !isOnAppInitDone) {
            triggerCondition(getBasicCondition({
                launch: BASIC_TAG_LAUNCH_CONDITION.onAppInit,
                page,
                urlParams: getURLParams(location.search)
            }));
            setIsOnAppInitDone(true);
        }
    }, [page, isOnAppInitDone, triggerCondition, location.search]);
};
